import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';
const galleryContainer = document.querySelector('.gallery');
const loader = document.querySelector('.loader');
const loadMoreBtn = document.querySelector('.load-more');
let lightbox = new SimpleLightbox('.gallery a', {
    captionsData: 'alt',
    captionDelay: 250,
});
export function createGallery(images) {
     const markup = images
    .map(
        ({ webformatURL, largeImageURL, tags, likes, views, comments, downloads}) =>
            `<li class="gallery-item">
                <a class="gallery-link" href="${largeImageURL}">
                    <img class="gallery-image" src="${webformatURL}" alt="${tags}"/>
                    <div class="info">
                      <p><b>Likes:</b> ${likes}</p>
                      <p><b>Views:</b>${views}</p>
                      <p><b>Comments:</b>${comments}</p>
                      <p><b>Downloads:</b>${downloads}</p>
                    </div>
                </a>
            </li>`
    )
    .join('');
    galleryContainer.insertAdjacentHTML('beforeend', markup);
    lightbox.refresh();
}

export function clearGallery() {
    galleryContainer.innerHTML = '';
}

export function showLoadMoreButton() {
    loadMoreBtn.classList.remove('hidden');
}

export function hideLoadMoreButton() {
    loadMoreBtn.classList.add('hidden');
}

export function showLoader() {
    loader.classList.remove('hidden');
}
export function hideLoader() {
    loader.classList.add('hidden');
}